import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ToolbarComponent from './toolbar.component';
import DrawerComponent from './drawer.component';
import { withStyles, ClassNameMap } from '@mui/styles'
import stylesheet from '../patients/detail/detail-container.stylesheet'
import { environment } from '../../environments/environment';
import { setLoggedInUser } from '../../redux/common-data-slice';
import { RootState, useAppThunkDispatch } from '../../redux/store';
import { useAuth } from 'oidc-react';
import { useSelector } from 'react-redux';
import Helper from '../../utils/helper';

interface IProps extends RouteComponentProps {
  history: any;
  location: any;
  match: any;
  classes: ClassNameMap;
}

const OIDCNavbarComponent: React.FC<IProps> = ({ classes }) => {
  const [left, setLeft] = useState(false);
  const loggedInUser = useSelector((state: RootState) => state.commonData.loggedInUser)
  const dispatch = useAppThunkDispatch();
  const auth = useAuth() as any

  useEffect(() => {
    if (Helper.isOIDC()) {

      // If user already loaded in Redux, skip
      if (loggedInUser.email) {
        return;
      }

      // First, check sessionStorage for existing user info
      const sessionUserInfo = window.sessionStorage.getItem('sessionUserInfo');
      const encryptedTokenTS = window.sessionStorage.getItem('encryptedTokenTS');

      // Validate token timestamp
      if (encryptedTokenTS) {
        const tokenTimestamp = new Date().getTime();
        const timeDiff = tokenTimestamp - parseInt(encryptedTokenTS);

        // If token is older than 15 minutes, clear it
        if (timeDiff > 900000) {
          window.sessionStorage.removeItem('sessionUserInfo');
          window.sessionStorage.removeItem('encryptedTokenTS');
          window.sessionStorage.removeItem('tokenExpiry');
          localStorage.removeItem('access_token');
          // Don't continue with expired data
          return;
        }
      }

      // If we have valid session storage, use it
      if (sessionUserInfo && encryptedTokenTS) {
        try {
          const userInfo = JSON.parse(sessionUserInfo);
          dispatch(setLoggedInUser(userInfo));
          return; // Exit early, we're done
        } catch (e) {
          console.error('72: OIDC-navbar failed to parse sessionUserInfo:', e);
          // Continue to try auth.userData below
        }
      }

      // If no valid session storage, try to get from auth object
      if (auth?.userData?.profile) {
        const userProfile = { ...auth.userData.profile } as any;

        if (userProfile && Object.keys(userProfile).length > 0) {
          // Store in sessionStorage for future use
          const tokenTimestamp = new Date().getTime();
          window.sessionStorage.setItem('sessionUserInfo', JSON.stringify(userProfile));
          window.sessionStorage.setItem('encryptedTokenTS', tokenTimestamp.toString());

          dispatch(setLoggedInUser(userProfile));
        }
      }
    } else {
      // Non-OIDC environment (dev mode)
      if (!environment.okta.isEnabled) {
        const userInfo = {
          'email': "sourav_ghosh@atmanhealth.com",
          'email_verified': true,
          'family_name': "Provider",
          'given_name': "Dev",
          'locale': "en_US",
          'name': "Dev Provider",
        }
        dispatch(setLoggedInUser({ ...userInfo, roles: ['PROVIDER'] }))
      }
    }
  }, [auth?.userData, loggedInUser.email, dispatch]);

  const toggleDrawer = (event: any) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setLeft(false);
  };

  const openDrawer = () => setLeft(true);

  return (
    <div className={classes.navbar}>
      <ToolbarComponent
        openDrawerHandler={openDrawer}
        history={''}
        location={window.location}
        match={''}
        isOktaEnabled={false}
      />
      <DrawerComponent
        left={left}
        toggleDrawerHandler={toggleDrawer}
        history={''}
        location={''}
        match={''}
      />
    </div>
  );
};

export default withStyles(stylesheet)(OIDCNavbarComponent);